export default "__VITE_ASSET__DBBPmBZW__"